import React from 'react';

const MenuOptions = (props) => (
  <div className="header-builder-menu-options">
    Menu options
  </div>
);

export default MenuOptions;



// WEBPACK FOOTER //
// ./app/header-builder/components/MenuOptions.js